<!-- src/components/ScrollProgressCircle.vue -->
<template>
    <div class="scroll-progress-wrap">
        <el-progress class="el-progress" type="circle" :show-text="false" color="#0078d0" :percentage="scrollPercent"
            @click="backToTop">
        </el-progress>
    </div>
</template>

<script>
export default {
    name: 'ScrollProgressCircle',
    data() {
        return {
            scrollPercent: 0,
            timer: null
        }
    },
    computed: {
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
        this.handleScroll()
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
        if (this.timer) clearTimeout(this.timer)
    },
    methods: {
        // 计算滚动进度
        handleScroll() {
            // 简易节流，16ms 执行一次（贴合浏览器帧率），流畅不丢帧
            if (this.timer) return
            this.timer = setTimeout(() => {
                const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
                const clientHeight = document.documentElement.clientHeight
                const scrollHeight = document.documentElement.scrollHeight

                // 可滚动区域高度
                const scrollRange = scrollHeight - clientHeight
                if (scrollRange <= 0) {
                    this.scrollPercent = 0
                } else {
                    // 保留小数，实现 0~100 之间连续变化
                    this.scrollPercent = (scrollTop / scrollRange) * 100
                }
                this.timer = null
                console.log(this.scrollPercent, '----')
            }, 16)
        },
        backToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }
}
</script>

<style scoped>
.scroll-progress-wrap {
    position: fixed;
    right: 10px;
    bottom: 10px;
    z-index: 9999;
}

.el-progress {
    background-color: #fff;
    border-radius: 50%;
    transform: scale(.4);
}

.circle-inner {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 50%;
}


@media screen and (max-width: 1024px) {
    .el-progress {
        transform: scale(.3)
    }

    .scroll-progress-wrap {
        position: fixed;
        right: 10px;
        bottom: 10px;
        z-index: 9999;
    }
}

@media screen and (max-width: 768px) {
    .el-progress {
        transform: scale(.3)
    }

    .scroll-progress-wrap {
        position: fixed;
        right: 0;
        bottom: 0;
        z-index: 9999;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ScrollProgressCircle.vue